module.exports = __webpack_public_path__ + "img/adriaan-van-der-ploeg4.fb5558a5.png";